import React from "react";
import { Share, View, Button, StyleSheet } from "react-native";

const ShareScreen = () => {
  const onShare = async () => {
    try {
      const result = await Share.share({
        message:
          "Visit Kidz Brain Academy Website to Know more about us                                               http://www.kidzbrainacademy.com/                Install Kidz Brain App For Abacus and Vedic Maths Practice https://play.google.com/store/apps/details?id=com.laveshgarg80.kidzbrain",
      });
      if (result.action === Share.sharedAction) {
        if (result.activityType) {
          // shared with activity type of result.activityType
        } else {
          // shared
        }
      } else if (result.action === Share.dismissedAction) {
        // dismissed
      }
    } catch (error) {
      alert(error.message);
    }
  };
  return (
    <View style={styles.container}>
      <Button onPress={onShare} title="Share Our Website and App" />
    </View>
  );
};

const styles = StyleSheet.create({
  container: { flex: 1, justifyContent: "center", alignItems: "center" },
});

export default ShareScreen;
